// extracted by mini-css-extract-plugin
export default {"table":"table_table__QGl8x","tableStickyHead":"table_tableStickyHead__KYf9D","sortIcons":"table_sortIcons__vLl64"};